import styled from 'styled-components'

export default styled('div')`
  font-size: 18px;
  font-weight: 500;
`
